module.exports = "https://static.cdns.space/qurangrowth-temp/img/m2.83943996.webp";